module.exports = __webpack_public_path__ + "PTMETTAhome-8.a4650d7d.png";